module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_9005.512028c2.png";